'use client';

import { useCallback } from 'react';

import { useCurrentUserId } from '@ps/ui/contexts/auth';

import { useCommunityContext } from '../contexts/community/useCommunityContext';
import { toggleMessageSubscription } from '../functions/message/toggleMessageSubscription';

/**
 * Action-only hook for the per-message "Notifications" toggle — fires the
 * subscribe/unsubscribe endpoint (the server flips the current member's
 * subscription to this message's replies). Live "am I subscribed?" state is read
 * separately from the membership doc (`useMyChannelMembership`).
 */
export function useToggleMessageNotification({
  channelId,
  messageId,
}: {
  channelId: string;
  messageId: string;
}) {
  const { creatorId } = useCommunityContext();
  const currentUserId = useCurrentUserId();

  return useCallback(async () => {
    if (!creatorId || !currentUserId) return;
    await toggleMessageSubscription({ creatorId, channelId, messageId });
  }, [creatorId, currentUserId, channelId, messageId]);
}
